import React from 'react'
import { Flexbox } from '../action/Flexbox'
import Logo from '../Logo/Logo'

const HumanTag = () => {
  return (
   <Flexbox className='human_tag' gap='0.2rem'>
    <Logo width={'0.6rem'} height={'0.6rem'} src={require('../../logo.png')} />
    <h6>A</h6>
   </Flexbox>
  )
}

export default HumanTag